import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    /* 検索窓のレイアウト調整 */
    searchContainer: {
      marginBottom: '16px'
    },
    searchPeriodWrapper: {
      display: 'inline-block',
      marginRight: '16px'
    },
    displaySwitchWrapper: {
      display: 'inline-block'
    },
    waveDash: {
      textAlign: 'center',
      display: 'inline-block',
      paddingRight: '8px',
      paddingLeft: '8px'
    },
    dateInput: {
      width: '145px'
    },
    noDataMesage: {
      textAlign: 'center',
      padding: '32px'
    },
    checkBoxLabel: {
      fontSize: '14px'
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginTop: '16px',
      marginLeft: '16px',
      marginRight: '16px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    },
    issueButtonWrapper: {
      display: 'inline-block',
      marginLeft: '16px',
      [theme.breakpoints.only('xs')]: {
        display: 'block',
        textAlign: 'right'
      }
    },
    issueButton: {
      textDecoration: 'underline'
    }
  });
});
